import { useDrawer } from 'src/hooks/useDrawer';
import { Logo } from 'src/config/components/Logo';
import { Link } from 'react-router';
import { memo } from 'react';
import { SidebarContent } from './components/SidebarContent';
import { Close } from 'src/svg/Closes';
import { useRoute } from 'src/router/hooks/useRoute';
import { SidebarButtons } from './components/Buttons';
import { Search } from '../../../components/Search';

const _Sidebar = () => {
  const { isLeftDrawerOpen, closeDrawer } = useDrawer();
  const { ROUTE } = useRoute();

  /** @todo возможно больше не пригодится. Если багов не нашлось - удаляем */
  // useEffect(() => {
  //   isTopDrawerOpen && closeLeftDrawer?.();
  // }, [closeLeftDrawer, isTopDrawerOpen]);

  return (
    <div
      className="z-[750] flex flex-col h-full bg-bg_sidebar w-full"
      style={{
        transform: isLeftDrawerOpen ? 'translateX(0px)' : 'translateX(-250px)'
      }}>
      <div className="px-4 pt-3">
        <div className="w-full flex justify-end items-center h-7 cursor-pointer">
          <Close onClick={closeDrawer} />
        </div>
        <div className="w-full flex justify-center gap-5 flex-col">
          <Link
            to={ROUTE.MAIN.get()}
            className="flex justify-center items-center w-full"
            onClick={closeDrawer}>
            <Logo className="w-48" />
          </Link>
          <SidebarButtons />
          <Search />
        </div>
      </div>

      <div className="overflow-y-auto px-4 pb-10 mt-5">
        <SidebarContent />
      </div>
    </div>
  );
};

// eslint-disable-next-line no-restricted-exports
export const Sidebar = memo(_Sidebar);
